import { legacyApi } from 'apps/migration/app/services/legacyApi';
import { legacyTypes } from './constants';
export class LegacyActions {
  static listLegacy(data: any) {
    return {
      type: legacyTypes.LIST_LEGACY,
      payload: { data },
    };
  }

  static listLegacySuccess(data: any) {
    return {
      type: legacyTypes.LIST_LEGACY_SUCCESS,
      payload: { data },
    };
  }
  static listLegacyFail(data: any) {
    return {
      type: legacyTypes.LIST_LEGACY_FAIL,
      payload: { data },
    };
  }

  static getLegacyBatch() {
    return legacyApi.get('product/category');
  }

  static createLegacyRequest(payload: any) {
    return legacyApi.post(`product/category`, payload);
  }

  static getOneItem(id: string) {
    return legacyApi.get(`product/category/${id}`);
  }

  static updateLegacyItem(id: string, payload: any) {
    return legacyApi.put(`product/category/${id}`, payload);
  }
  static deleteItem(id: string) {
    return legacyApi.delete(`product/category/${id}`);
  }
}
